function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "inventory-management",
  transform: "translate(-2.25 -2.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11496",
  "data-name": "Path 11496",
  d: "M21.375,27h11.13V38.13H21.375Z",
  transform: "translate(28.178 36.466)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11497",
  "data-name": "Path 11497",
  d: "M29.25,27H40.38V38.13H29.25Z",
  transform: "translate(39.781 36.466)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11498",
  "data-name": "Path 11498",
  d: "M21.375,19.125h11.13v11.13H21.375Z",
  transform: "translate(28.178 24.863)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11499",
  "data-name": "Path 11499",
  d: "M29.25,19.125H40.38v11.13H29.25Z",
  transform: "translate(39.781 24.863)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11500",
  "data-name": "Path 11500",
  d: "M43.988,63.466H7.815V24.51H74.6V38.423h5.565V24.51A5.57,5.57,0,0,0,74.6,18.945H57.9V7.815A5.57,5.57,0,0,0,52.335,2.25H30.075A5.57,5.57,0,0,0,24.51,7.815v11.13H7.815A5.57,5.57,0,0,0,2.25,24.51V63.466a5.57,5.57,0,0,0,5.565,5.565H43.988ZM30.075,7.815h22.26v11.13H30.075Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
}));

var SvgInventoryManagement = function SvgInventoryManagement(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77.911,
    height: 72.346,
    viewBox: "0 0 77.911 72.346",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInventoryManagement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inventory-management.7e1692e4.svg";
export { ForwardRef as ReactComponent };